import React from "react";
import "./Bacterial.css";

const Bacterial = () => {
  return (
    <div className="parent-bacterial d-flex justify-content-evenly row">
      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/laboratory-tests-for-viral-infections"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/skin-swab.jpg"
            class="card-img-top"
            alt="skin-swab"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Skin swabs for bacterial and viral infections
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/laboratory-tests-for-fungal-infection"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/skin-scrapping.jpg"
            class="card-img-top"
            alt="skin-scrapings"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Skin scrapings for fungal infections
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/laboratory-tests-for-fungal-infection"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/nail_hair.jpg"
            class="card-img-top"
            alt=" Nail and hair"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Nail and hair microscopy/culture
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/liquid-nitrogencryotherapy-guidelines"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/cryotherapy.jpg"
            class="card-img-top"
            alt="Cyrotherapy"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Cyrotherapy
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/patch-tests"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/patch_test.jpg"
            class="card-img-top"
            alt="Patch-testing"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Patch testing
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/excision-of-skin-lesions"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/skin_biopsy.jpg"
            class="card-img-top"
            alt="skin-scrapings"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Skin biopsy
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/skin-surgery"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/skin_surgery.jpg"
            class="card-img-top"
            alt=" Nail and hair"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Skin surgery for moles and skin cancer
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/intralesional-steroid-injection"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/steroid.jpg"
            class="card-img-top"
            alt="Cyrotherapy"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Steroid injections into skin and scalp
            </h6>
          </div>
        </a>
      </div>

      {/* <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/cme/phototherapy/photodynamic-therapy-cme"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/photodynamic-therapy.jpg"
            class="card-img-top"
            alt="Photodynamic"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Photodynamic therapy for sun damage and skin cancer
            </h6>
          </div>
        </a>
      </div> */}

      {/* <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/cme/phototherapy/photodynamic-therapy-cme"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/botox_injection.jpg"
            class="card-img-top"
            alt="skin-scrapings"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                fontWeight: "660",
              }}
            >
              Botox injections
            </h6>
          </div>
        </a>
      </div> */}

      {/* <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/cme/phototherapy/photodynamic-therapy-cme"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/dermal_fillers.jpg"
            class="card-img-top"
            alt=" Nail and hair"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                fontWeight: "660",
              }}
            >
              Dermal fillers
            </h6>
          </div>
        </a>
      </div> */}

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/dermoscopy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/dermoscopy.jpg"
            class="card-img-top"
            alt="Cyrotherapy"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Dermoscopy
            </h6>
          </div>
        </a>
      </div>

      <div
        class="card col-lg-4 col-md-4 col-sm-12 bacterial-row-gap"
        style={{ width: "18rem" }}
      >
        <a
          href="https://dermnetnz.org/topics/electrosurgery"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src="/diseasePic/electrocoagulation.jpg"
            class="card-img-top"
            alt="Electrocoagulation"
          />
          <div class="card-body">
            <h6
              class="card-title text-center"
              style={{
                color: "black",
                fontFamily: " sans-serif",
                // fontWeight: "660",
              }}
            >
              Electrocoagulation
            </h6>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Bacterial;
